(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('wj-pdp-v98')) return;
  class WrapJktPDP98 extends HTMLElement {
    connectedCallback() {
      if (this._ready || this._frame) return;
      this._frame = requestAnimationFrame(() => { this._frame = null; if (this.isConnected) this.init(); });
    }
    disconnectedCallback() {
      if (this._frame) cancelAnimationFrame(this._frame);
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._viewportFrame) cancelAnimationFrame(this._viewportFrame);
      if (this._reelFrame) cancelAnimationFrame(this._reelFrame);
      if (this._resize) this._resize.disconnect();
      this._accentToken=(this._accentToken||0)+1;
      clearTimeout(this._scrollEndTimer);
      clearInterval(this._deliveryTimer);
      if (this._videoObserver) this._videoObserver.disconnect();
      this.querySelectorAll("dialog[open]").forEach(dialog => { dialog.close(); this.afterDialogClose(dialog); });
      this._targetIndex = null;
      (this._events || []).forEach(([node, type, fn, options]) => node.removeEventListener(type, fn, options));
      this._events = []; this._ready = false; this._frame = null;
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this._zoomOpen) this.closeZoom();
    }
    on(node, type, fn, options) {
      if (!node) return;
      node.addEventListener(type, fn, options);
      this._events.push([node, type, fn, options]);
    }
    init() {
      const config = this.querySelector('[data-config]');
      if (!config || this._ready) return;
      try { this.config = window.WJI18n.data(JSON.parse(config.textContent)); } catch (_) { return; }
      this._events = []; this._busy = false; this._uncertain = false;
      this._markedIndex = null; this._viewportFrame = null; this._reelFrame = null;
      this._accentCache = this._accentCache || new Map();
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.select = this.querySelector('[data-variant-select]');
      this.form = this.querySelector('[data-main-form]');
      this.packForm = this.querySelector('[data-pack-form]');
      this.mainButton = this.querySelector('[data-main-submit]');
      this.packButton = this.querySelector('[data-pack-submit]');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyButton = this.querySelector('[data-sticky-submit]');
      this.packSelects = Array.from(this.querySelectorAll('[data-pack-select]'));
      this.variants = new Map(this.config.variants.map(v => [String(v.id), v]));
      this._allSlides = this.slides.slice(); this._allThumbs = this.thumbs.slice();
      this.prepareGalleryOwners();
      try { this.money = new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency', currency:this.config.currency}); }
      catch (_) { this.money = {format: n => n.toFixed(2) + ' ' + this.config.currency}; }
      this._reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.index = Math.max(0, Math.min(this.slides.length - 1, Number(this.dataset.initialIndex) || 0));
      this.on(this, 'click', event => this.click(event));
      this.querySelectorAll('[data-accordion]').forEach(detail => {
        this.on(detail.querySelector('summary'), 'click', event => {
          event.preventDefault();
          this.setAccordion(detail, !detail.open, true);
        });
      });
      this.on(this, 'change', event => {
        if (event.target === this.select) this.selectVariant(this.select.value, true);
        if (this.packSelects.includes(event.target)) { this._packEdited = true; this.updatePack(); }
      });
      this.on(this, 'submit', event => {
        if (event.target !== this.form && event.target !== this.packForm) return;
        // Native form fallback remains available when fetch/URL are unavailable.
        if (!window.fetch || !window.URL) return;
        event.preventDefault(); event.stopPropagation();
        if (this._busy || this._uncertain) return;
        const isPack = event.target === this.packForm;
        const ids = isPack ? this.packSelects.map(s => s.value) : [this.select.value];
        if (!ids.every(id => this.variants.get(id) && this.variants.get(id).available)) return;
        if (isPack && this.packButton.disabled) return;
        this.add(ids, isPack);
      });
      this._targetIndex = null;
      this._galleryWidth = this.track ? this.track.getBoundingClientRect().width : 0;
      this.on(this.track, 'scroll', () => {
        clearTimeout(this._scrollEndTimer);
        this._scrollEndTimer = setTimeout(() => this.finishGallery(), 180);
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          if (this._targetIndex === null) this.markSlide(this.closestSlide());
        });
      }, {passive:true});
      this.on(this.track, 'scrollend', () => this.finishGallery());
      const interruptGallery = () => {
        this._targetIndex = null;
        clearTimeout(this._scrollEndTimer);
        this.markSlide(this.closestSlide());
      };
      this.on(this.track, 'pointerdown', interruptGallery, {passive:true});
      this.on(this.track, 'touchstart', interruptGallery, {passive:true});
      this.on(this.track, 'wheel', interruptGallery, {passive:true});
      this.on(this.track, 'keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      this.on(window, 'popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        this.selectVariant(id || this.config.selected, false);
      });
      this.on(window, 'scroll', () => this.scheduleViewport(), {passive:true});
      this.on(window, 'resize', () => this.scheduleViewport(true), {passive:true});
      this.on(document, 'keydown', event => this.zoomKeys(event));
      this.on(this, 'keydown', event => { if (event.key === 'Escape' && this.querySelector('[data-pack-picker]') && !this.querySelector('[data-pack-picker]').hidden) { event.preventDefault(); this.closePack(true); } });
      this.querySelectorAll('video').forEach(video => {
        this.on(video, 'play', () => this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }));
      });
      this.querySelectorAll('img').forEach(img => {
        this.on(img, 'error', () => {
          // Retry a failed responsive candidate once using the original src.
          if ((!img.hasAttribute('srcset') && !img.dataset.wjOriginal) || img.dataset.wjRetried) return;
          img.dataset.wjRetried = 'true'; img.removeAttribute('srcset'); img.removeAttribute('sizes');
          if (img.dataset.wjOriginal) img.src = img.dataset.wjOriginal;
        });
      });
      this._ready = true;
      this.classList.add('has-js');
      this.querySelectorAll('[data-js-only]').forEach(el => { el.hidden = false; });
      this.selectVariant(this.select.value || this.config.selected, false);
      if(this.dataset.kind==='denim' && this.variants.get(this.select.value)?.title==='Denim Lavado') {
        const cover=this.slides.findIndex(slide=>slide.hasAttribute('data-denim-product-cover'));
        if(cover>=0)this.go(cover,false);
      }
      const firstAvailable = this.config.variants.find(v => v.available);
      this.packSelects.forEach(select => {
        const chosen = this.variants.get(select.value);
        if ((!chosen || !chosen.available) && firstAvailable) select.value = firstAvailable.id;
      });
      this.updatePack();
      this.initPresentation();
      this.measureGallery();
      this.go(this.index, false);
      this.updateSticky();
      if (window.ResizeObserver && this.track) {
        this._resize = new ResizeObserver(() => this.alignGalleryWidth());
        this._resize.observe(this.track);
      }
      this.dispatchEvent(new CustomEvent('wrapjkt:ready',{bubbles:true}));
    }
    // Calendar arithmetic in the store's timezone. Weekends count; no guessed dispatch date.
    deliveryDates(now = new Date()) {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Atlantic/Canary',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
      const get = key => Number(parts.find(p => p.type === key).value);
      const today = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
      const end = new Date(today);
      const days = Math.max(1, Math.min(60, Number(this.config.deliveryDays) || 8));
      end.setUTCDate(end.getUTCDate() + days);
      const label = d => new Intl.DateTimeFormat(document.documentElement.lang||'es',{day:'numeric',month:'short',timeZone:'UTC'}).format(d);
      return {today:label(today), end:label(end), iso:today.toISOString().slice(0,10), days};
    }
    updateDelivery() {
      const panel = this.querySelector('[data-delivery]');
      if (!panel) return;
      panel.hidden = !!this.current && !this.current.available;
      try {
        const d = this.deliveryDates();
        this.querySelector('[data-delivery-today]').textContent = 'Hoy · ' + d.today;
        this.querySelector('[data-delivery-date]').textContent = 'Hasta el ' + d.end;
        this.querySelector('[data-delivery-lead]').textContent = 'Si pides hoy: entrega estimada hasta el ' + d.end + '.';
        panel.dataset.calendarDate = d.iso;
      } catch (_) {
        // Keep the Liquid text usable on engines without full Intl timezone support.
        panel.querySelector('.w97-timeline').hidden = true;
      }
    }
    initPresentation() {
      this.updateDelivery();
      this._deliveryTimer = setInterval(() => { if (!document.hidden) { this.updateDelivery(); if(this.current&&this.config.dropClosesAt){const availability=this.querySelector('[data-availability]');if(availability)availability.textContent=this.stockMessage(this.current);const edition=this.querySelector('[data-edition-message]');if(edition)edition.textContent=this.stockMessage(this.current);} } }, 60000);
      this.on(document, 'visibilitychange', () => {
        if (!document.hidden) this.updateDelivery();
        else this.querySelectorAll('video').forEach(v => v.pause());
      });
      this.querySelectorAll('.w97-dialog').forEach(dialog => {
        this.on(dialog, 'close', () => this.afterDialogClose(dialog));
        this.on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        });
      });
      const player = this.querySelector('[data-story-player]');
      this.on(player, 'error', () => { this.querySelector('[data-story-error]').hidden = false; });
      const rail = this.querySelector('[data-reel-track]');
      this.on(rail, 'scroll', () => this.scheduleReelNav(), {passive:true});
      this.on(window, 'resize', () => this.scheduleReelNav(), {passive:true});
      this.updateReelNav();
      if (window.IntersectionObserver) {
        this._videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting && !entry.target.closest('dialog')) entry.target.pause();
        }), {threshold:0});
        this.querySelectorAll('video:not([data-story-player])').forEach(v => this._videoObserver.observe(v));
      }
    }
    scheduleViewport(resize = false) {
      this._needsViewportResize = this._needsViewportResize || resize;
      if (this._viewportFrame) return;
      this._viewportFrame = requestAnimationFrame(() => {
        this._viewportFrame = null;
        if (!this.isConnected) return;
        if (this._needsViewportResize) { this._needsViewportResize = false; this.alignGalleryWidth(); this.updateSwatches(); }
        this.updateSticky();
      });
    }
    scheduleReelNav() {
      if (this._reelFrame) return;
      this._reelFrame = requestAnimationFrame(() => {
        this._reelFrame = null;
        if (this.isConnected) this.updateReelNav();
      });
    }
    updateReelNav() {
      const rail = this.querySelector('[data-reel-track]');
      if (!rail) return;
      const previous = this.querySelector('[data-reel-nav="-1"]');
      const next = this.querySelector('[data-reel-nav="1"]');
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      previous.parentElement.hidden = rail.scrollWidth <= rail.clientWidth + 2;
    }
    showDialog(dialog, trigger) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (dialog.open) return true;
      this._dialogReturn = trigger;
      this._dialogOverflow = document.body.style.overflow;
      try { dialog.showModal(); } catch (_) { return false; }
      document.body.style.overflow = 'hidden';
      this.classList.add('has-dialog');
      this.querySelectorAll('video').forEach(v => v.pause());
      this.updateSticky();
      return true;
    }
    afterDialogClose(dialog) {
      if (dialog.querySelector('[data-story-player]')) {
        const video = dialog.querySelector('video');
        video.pause(); video.removeAttribute('src'); video.load();
        this.querySelector('[data-story-error]').hidden = true;
      }
      if (dialog.hasAttribute('data-info-dialog')) dialog.querySelector('[data-info-content]').replaceChildren();
      document.body.style.overflow = this._dialogOverflow || '';
      this.classList.remove('has-dialog');
      if (this._dialogReturn && this._dialogReturn.isConnected) this._dialogReturn.focus({preventScroll:true});
      this.updateSticky();
    }
    openStory(trigger) {
      const dialog = this.querySelector('[data-story-dialog]');
      if (!this.showDialog(dialog, trigger)) return false;
      this.querySelector('[data-story-dialog-title]').textContent = trigger.dataset.storyTitle;
      const caption = this.querySelector('[data-story-dialog] [data-story-caption]');
      if (caption && trigger.dataset.storyCaption) caption.textContent = trigger.dataset.storyCaption;
      const player = this.querySelector('[data-story-player]');
      const poster = trigger.querySelector('img');
      if (trigger.dataset.storyPoster) player.poster = trigger.dataset.storyPoster;
      else if (poster) player.poster = poster.currentSrc || poster.src; else player.removeAttribute('poster');
      this.querySelector('[data-story-error]').hidden = true;
      this.querySelector('[data-story-fallback]').href = trigger.href;
      player.src = trigger.href; player.muted = true;
      const play = player.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
      return true;
    }
    openInfo(trigger) {
      const target = document.getElementById(trigger.getAttribute('href').slice(1));
      const original = target && target.querySelector('.w-edu-content');
      const dialog = this.querySelector('[data-info-dialog]');
      if (!original || !dialog || typeof dialog.showModal !== 'function') return false;
      const copy = original.cloneNode(true);
      dialog.dataset.topic = target.id.split('-').pop();
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      copy.querySelectorAll('[data-zoom-link]').forEach(link => {
        link.removeAttribute('data-zoom-link'); link.target='_blank'; link.rel='noopener';
      });
      const title = target.querySelector('.w-summary-copy');
      this.querySelector('[data-info-title]').textContent = title ? title.firstChild.textContent.trim() : 'Te ayudamos a elegir';
      this.querySelector('[data-info-content]').replaceChildren(...Array.from(copy.childNodes));
      this.dispatchEvent(new CustomEvent('wrapjkt:info-open', {bubbles:true}));
      return this.showDialog(dialog, trigger);
    }
    presentationClick(event, button) {
      if (button.hasAttribute('data-close-dialog')) { const dialog=button.closest('dialog'); if (dialog && dialog.open) dialog.close(); return true; }
      if (button.hasAttribute('data-story-open') && this.openStory(button)) { event.preventDefault(); return true; }
      if (button.hasAttribute('data-quick-info') && this.openInfo(button)) { event.preventDefault(); return true; }
      if (button.hasAttribute('data-reel-nav')) {
        const rail = this.querySelector('[data-reel-track]');
        rail.scrollBy({left:Number(button.dataset.reelNav) * rail.clientWidth * .85,behavior:this._reduced?'auto':'smooth'});
        return true;
      }
      return false;
    }
    updateDetailPhoto(variant) {
      if (this.config.detailFixed) return;
      const photo = this.querySelector('.w97-design-photo');
      if (!photo) return;
      const img = photo.querySelector('img');
      const source = variant.detail || this.resolveVariantVisual(variant).src;
      photo.hidden = !source || !img;
      if (!img || !source) return;
      const url = new URL(source, window.location.href); url.searchParams.set('width','960');
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url.href;
      img.alt = this.config.title + ' · ' + variant.title;
      this.querySelector('[data-detail-color]').textContent = variant.title;
    }

    openPack(slot) {
      if (this._busy || this._uncertain || !this.packSelects[slot]) return;
      const panel = this.querySelector('[data-pack-picker]');
      if (this._packSlot === slot && !panel.hidden) { this.closePack(true); return; }
      this._packSlot = slot; panel.hidden = false;
      this.querySelector('[data-pack-picker-title]').textContent = 'Elige para la chaqueta ' + (slot + 1);
      this.querySelectorAll('[data-pack-toggle]').forEach(button => button.setAttribute('aria-expanded',String(Number(button.dataset.packToggle) === slot)));
      let selected;
      this.querySelectorAll('[data-pack-choice]').forEach(button => {
        const variant = this.variants.get(button.dataset.packChoice), image = button.querySelector('img');
        if (image && variant) { const source = variant.swatch || variant.sample || variant.thumb || variant.card || variant.image; if (source && image.getAttribute('src') !== source) image.src = source; image.loading = 'eager'; }
        const active = button.dataset.packChoice === this.packSelects[slot].value;
        button.setAttribute('aria-pressed',String(active)); if (active && !button.disabled) selected=button;
      });
      const focus = selected || panel.querySelector('[data-pack-choice]:not(:disabled)') || panel.querySelector('[data-close-pack]');
      focus.focus({preventScroll:true});
      const grid = panel.querySelector('.w-pack-options');
      if (selected) grid.scrollTop += selected.getBoundingClientRect().top - grid.getBoundingClientRect().top;
      this.updateSticky();
      const rect=panel.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight - 90) panel.scrollIntoView({behavior:this._reduced ? 'auto' : 'smooth',block:'center'});
    }
    closePack(focus) {
      this.querySelector('[data-pack-picker]').hidden=true;
      this.updateSticky();
      this.querySelectorAll('[data-pack-toggle]').forEach(button => button.setAttribute('aria-expanded','false'));
      if (focus && this._packSlot != null) this.querySelector('[data-pack-toggle="'+this._packSlot+'"]').focus({preventScroll:true});
    }
    setAccordion(detail, open, preserve) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        // Desktop: independent panels do not collapse content above the reader.
        detail.open = open;
        if (!open) detail.querySelectorAll('video').forEach(v => v.pause());
        if (open && !this._reduced) {
          const content = detail.querySelector('.w-edu-content');
          if (content && content.animate) content.animate([{opacity:0},{opacity:1}], {duration:180,easing:'ease-out'});
        }
        return;
      }
      const summary = detail.querySelector('summary');
      const before = summary.getBoundingClientRect().top;
      if (open) this.querySelectorAll('[data-accordion]').forEach(other => {
        if (other !== detail) { other.open = false; other.querySelectorAll('video').forEach(v => v.pause()); }
      });
      detail.open = open;
      if (!open) detail.querySelectorAll('video').forEach(v => v.pause());
      if (preserve) {
        const delta = summary.getBoundingClientRect().top - before;
        if (Math.abs(delta) > 1) window.scrollBy(0, delta);
      }
    }
    setAccent(rgb) {
      if(window.WJColor){window.WJColor.apply(this,rgb);return;}
      const lum=c=>{c/=255;return c<=.04045?c/12.92:Math.pow((c+.055)/1.055,2.4);};
      const light=c=>.2126*lum(c[0])+.7152*lum(c[1])+.0722*lum(c[2]);
      const ink=rgb.slice();
      while(light(ink)>.17) for(let i=0;i<3;i++)ink[i]*=.94;
      this.style.setProperty('--w-dynamic-color',rgb.map(Math.round).join(', '));
      this.style.setProperty('--w-accent-ink',ink.map(Math.round).join(', '));
      this.style.setProperty('--w-accent-on',light(rgb)>.179?'#111111':'#ffffff');
    }
    dominantColor(pixels, size) {
      // Percentage map of the central garment region. Similar shades are grouped
      // in perceptual Lab space so shadows do not split a dominant print colour.
      const lab=rgb=>{
        const c=rgb.map(v=>{v/=255;return v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4);});
        const f=v=>v>.008856?Math.cbrt(v):7.787*v+16/116;
        const x=f((.4124564*c[0]+.3575761*c[1]+.1804375*c[2])/.95047);
        const y=f(.2126729*c[0]+.7151522*c[1]+.072175*c[2]);
        const z=f((.0193339*c[0]+.119192*c[1]+.9503041*c[2])/1.08883);
        return [116*y-16,500*(x-y),200*(y-z)];
      };
      const distance=(a,b)=>a.reduce((sum,v,i)=>sum+(v-b[i])**2,0);
      const bins=new Map();let total=0;
      for(let y=Math.floor(size*.28);y<size*.62;y++)for(let x=Math.floor(size*.34);x<size*.66;x++){
        const i=(y*size+x)*4;if(pixels[i+3]<220)continue;
        const rgb=[pixels[i],pixels[i+1],pixels[i+2]],key=rgb.map(v=>Math.floor(v/16)).join('-');
        let bin=bins.get(key);if(!bin){bin={count:0,sum:[0,0,0]};bins.set(key,bin);}
        bin.count++;total++;rgb.forEach((v,j)=>bin.sum[j]+=v);
      }
      if(!total){this._dominantPalette=[];return null;}
      const points=Array.from(bins.values()).map(b=>{const rgb=b.sum.map(v=>v/b.count);return {rgb,lab:lab(rgb),count:b.count};}).sort((a,b)=>b.count-a.count);
      let centers=[points[0].lab.slice()];
      while(centers.length<6){
        let best,score=0;
        points.forEach(point=>{const d=Math.min(...centers.map(c=>distance(c,point.lab)));const value=point.count*d;if(d>225&&value>score){best=point;score=value;}});
        if(!best)break;centers.push(best.lab.slice());
      }
      let groups;
      for(let pass=0;pass<10;pass++){
        groups=centers.map(()=>({count:0,sum:[0,0,0],labSum:[0,0,0]}));
        points.forEach(point=>{
          let nearest=0,d=Infinity;centers.forEach((center,i)=>{const value=distance(center,point.lab);if(value<d){d=value;nearest=i;}});
          const g=groups[nearest];g.count+=point.count;
          point.rgb.forEach((v,i)=>g.sum[i]+=v*point.count);point.lab.forEach((v,i)=>g.labSum[i]+=v*point.count);
        });
        centers=groups.map((g,i)=>g.count?g.labSum.map(v=>v/g.count):centers[i]);
      }
      const palette=groups.filter(g=>g.count).map(g=>({count:g.count,rgb:g.sum.map(v=>v/g.count),lab:g.labSum.map(v=>v/g.count)}));
      // Merge nearby shades before ranking area coverage, not saturation.
      let merged=true;
      while(merged){
        merged=false;let pair=null,best=400;
        for(let i=0;i<palette.length;i++)for(let j=i+1;j<palette.length;j++){
          const d=distance(palette[i].lab,palette[j].lab);if(d<best){best=d;pair=[i,j];}
        }
        if(pair){const [i,j]=pair,a=palette[i],b=palette[j],n=a.count+b.count;
          a.rgb=a.rgb.map((v,k)=>(v*a.count+b.rgb[k]*b.count)/n);
          a.lab=a.lab.map((v,k)=>(v*a.count+b.lab[k]*b.count)/n);a.count=n;palette.splice(j,1);merged=true;
        }
      }
      palette.sort((a,b)=>b.count-a.count);
      this._dominantPalette=palette.map(g=>({rgb:g.rgb.map(Math.round),percentage:100*g.count/total}));
      // On prints, a neutral backdrop can dominate the crop while shades of the
      // same printed colour split into several clusters. Aggregate hue families
      // using their actual pixel coverage, not a brightest-pixel shortcut.
      if(this.dataset.kind==='estampada'){
        const coloured=points.map(point=>{
          const [l,a,b]=point.lab;
          return {...point,chroma:Math.hypot(a,b),hue:(Math.atan2(b,a)*180/Math.PI+360)%360,l};
        }).filter(point=>point.chroma>=22&&point.l>=18&&point.l<=94);
        // Overlapping hue windows avoid splitting a blue/yellow family at bin boundaries.
        const candidates=coloured.map(seed=>{
          const family={count:0,sum:[0,0,0]};
          coloured.forEach(point=>{
            const diff=Math.abs(seed.hue-point.hue);
            if(Math.min(diff,360-diff)>25)return;
            family.count+=point.count;
            point.rgb.forEach((v,i)=>family.sum[i]+=v*point.count);
          });
          return family;
        }).sort((a,b)=>b.count-a.count);
        const candidate=candidates[0],winner=palette[0];
        const neutral=Math.hypot(winner.lab[1],winner.lab[2])<25;
        if(candidate&&candidate.count/total>=.15&&
          ((neutral&&candidate.count>=winner.count*.22)||candidate.count>winner.count)){
          return candidate.sum.map(v=>Math.round(v/candidate.count));
        }
      }
      return this._dominantPalette[0].rgb;
    }
    prepareGalleryOwners() {
      if (!['denim','waterproof'].includes(this.dataset.kind)) return;
      const byId = new Map(this._allSlides.map(slide => [String(slide.dataset.mediaId),slide]));
      const byPosition = new Map(this._allSlides.map(slide => [Number(slide.dataset.mediaPosition),slide]));
      const featuredIds = new Set(this.config.variants.map(variant => String(variant.mediaId)));
      for (const variant of this.config.variants) {
        const slide = byId.get(String(variant.mediaId));
        if (!slide) continue;
        slide.dataset.galleryOwner = String(variant.id);
        const following = byPosition.get(Number(slide.dataset.mediaPosition) + 1);
        if (following && following.dataset.mediaType === 'image' && !featuredIds.has(String(following.dataset.mediaId))) following.dataset.galleryOwner = String(variant.id);
      }
      const cover = this._allSlides.find(slide => slide.hasAttribute('data-denim-product-cover'));
      if (cover) cover.dataset.galleryOwner = String(this.config.variants.find(variant => variant.title === 'Denim Lavado')?.id || '');
    }
    filterGallery(variant) {
      if (!['denim','waterproof'].includes(this.dataset.kind)) return;
      const hasCover = this._allSlides.some(slide => slide.hasAttribute('data-denim-product-cover') && slide.dataset.galleryOwner === String(variant.id));
      const slides = [], thumbs = [];
      this._allSlides.forEach((slide,index) => {
        const owner = slide.dataset.galleryOwner;
        const duplicateCover = hasCover && String(slide.dataset.mediaId) === String(variant.mediaId);
        const show = (!owner || owner === String(variant.id)) && !duplicateCover;
        slide.hidden = !show;
        const thumb = this._allThumbs[index];
        if (thumb) { thumb.hidden = !show; if (show) { thumb.dataset.thumb = String(slides.length); thumbs.push(thumb); } }
        if (show) slides.push(slide);
      });
      this.slides = slides; this.thumbs = thumbs; this.index = 0; this._targetIndex = null;
      this.measureGallery();
    }
    resolveVariantVisual(variant) {
      const path=src=>{try{return new URL(src,window.location.href).pathname;}catch(_){return '';}};
      const own=variant.image||'';
      let index=this.slides.findIndex(slide=>String(slide.dataset.mediaId)===String(variant.mediaId)&&variant.mediaId);
      if(own){
        const match=this.slides.findIndex(slide=>Array.from(slide.querySelectorAll('img')).some(img=>path(img.dataset.wjOriginal||img.currentSrc||img.src)===path(own)));
        if(match>=0)index=match;
      }
      const image=index>=0?this.slides[index].querySelector('img'):null;
      return {src:own||(image&&(image.currentSrc||image.src))||'',index};
    }
    syncVariantVisual(variant) {
      const visual=this.resolveVariantVisual(variant);
      const sticky=this.querySelector('[data-sticky-image]');
      sticky.hidden=!visual.src;
      sticky.removeAttribute('srcset');sticky.removeAttribute('sizes');
      if(visual.src){sticky.dataset.wjOriginal=visual.src;delete sticky.dataset.wjRetried;sticky.src=variant.thumb||visual.src;sticky.alt=this.config.title+' · '+variant.title;}
      else {sticky.removeAttribute('src');sticky.alt='';}
      this.applyAccent(variant.sample||visual.src,variant.id);
      if(visual.index>=0)this.go(visual.index,false);
    }
    applyAccent(src, variantId) {
      const token=this._accentToken=(this._accentToken||0)+1;
      const selected=String(variantId);
      const known=window.WJColor?.lookup(this.dataset.kind,this.variants.get(selected)?.title);
      if(known){this.setAccent(known);this.dataset.accentStatus='catalogue-palette';return;}
      // Reviewed garment sample: median RGB from the central 35–65% crop
      // of the Denim Lavado product photograph, excluding the pale backdrop.
      const accentVariant=this.variants.get(selected);
      if(this.dataset.kind==='denim' && accentVariant?.title==='Denim Lavado'){
        this.setAccent([129,173,215]);
        this.dataset.accentStatus='reviewed-denim-lavado';
        return;
      }
      const fallback=this.dataset.kind==='denim'?[42,60,76]:this.dataset.kind==='waterproof'?[62,76,57]:[67,56,70];
      const hexToRgb=value=>{
        const match=String(value||'').trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
        if(!match)return null;
        let hex=match[1];if(hex.length===3)hex=hex.split('').map(c=>c+c).join('');
        return [0,2,4].map(i=>parseInt(hex.slice(i,i+2),16));
      };
      const manual=this.dataset.kind==='estampada'?hexToRgb(this.dataset.accentOverride):null;
      if(manual){this.setAccent(manual);this.dataset.accentStatus='product-override';return;}
      if(this.dataset.kind==='estampada'){
        const node=this.querySelector('[data-print-profile]');
        try{
          const profile=node?window.WJI18n.data(JSON.parse(node.textContent)):null;
          const primary=profile&&hexToRgb(profile.primary);
          if(primary){this.setAccent(primary);this.dataset.accentStatus='reviewed-print-palette';return;}
        }catch(_){}
      }
      const cached=this._accentCache.get(src);
      if(cached){this.setAccent(cached);this.dataset.accentStatus='cached';return;}
      this.setAccent(fallback);
      this.dataset.accentStatus=src?'loading':'missing-image';
      if(!src)return;
      let url;try{url=new URL(src,window.location.href);url.searchParams.set('width','192');}catch(_){return;}
      // Fallback for products without a reviewed palette or explicit colour.
      const sample=new Image();sample.crossOrigin='anonymous';
      sample.onload=()=>{
        if(!this.isConnected||token!==this._accentToken||!this.current||String(this.current.id)!==selected)return;
        try{
          const canvas=document.createElement('canvas');canvas.width=canvas.height=64;
          const ctx=canvas.getContext('2d');if(!ctx)return;
          ctx.drawImage(sample,0,0,64,64);
          const rgb=this.dominantColor(ctx.getImageData(0,0,64,64).data,64);
          if(rgb){this._accentCache.set(src,rgb);this.setAccent(rgb);this.dataset.accentStatus='analysed';}
          else this.dataset.accentStatus='empty-sample';
        }catch(_){this.dataset.accentStatus='pixel-access-failed';}
      };
      sample.onerror=()=>{if(token===this._accentToken)this.dataset.accentStatus='image-load-failed';};sample.src=url.href;
    }
    stockMessage(variant) {
      const words=this.config.stockWords||{};
      if(!variant.available)return words[this.dataset.kind==='estampada'?'print_sold':'color_sold']||this.config.words.soldOut;
      if(variant.inventoryTracked&&variant.inventoryQuantity>0&&variant.inventoryQuantity<=5)return variant.inventoryQuantity===1?words.one:words.few.replace('__COUNT__',String(variant.inventoryQuantity));
      const closing=Date.parse(this.config.dropClosesAt||'');
      if(this.config.limited&&Number.isFinite(closing)&&closing>Date.now()){
        const date=new Intl.DateTimeFormat(document.documentElement.lang||'es',{day:'numeric',month:'long',year:'numeric',timeZone:'Atlantic/Canary'}).format(new Date(closing));
        return words.closing.replace('__DATE__',date);
      }
      if(this.config.limited)return words[this.config.noRestock?'no_restock':'limited'];
      return words[this.dataset.kind==='estampada'?'print':'color'];
    }
    updateEditionMessage(variant) {
      const limited=this.config.limited;
      const editionMessage=this.querySelector('[data-edition-message]');
      if(editionMessage)editionMessage.textContent=this.stockMessage(variant);
      if(limited){
        const pack=this.querySelector('.w-editorial-bundle');
        pack.querySelector('.w-bundle-alert').textContent='Dúo de edición · Una para ti, otra para compartir';
        pack.querySelector('.w-bundle-title').textContent='Hay diseños que merece la pena compartir.';
        const copy=pack.querySelectorAll('.w-bundle-text');
        copy[0].textContent='Si este estampado te ha elegido a ti, quizá ya sepas a quién le gustaría tanto como a ti. Conserva una pieza y regala la otra, o preparad juntas vuestro dúo.';
        copy[1].textContent=this.config.noRestock?'Esta edición no se repone cuando se agota. El dúo reúne dos unidades de este mismo estampado, mientras haya existencias.':'El dúo reúne dos unidades de este mismo estampado, según disponibilidad.';
        copy[2].innerHTML='<strong>Dos piezas de este producto, con un 10% de descuento en ambas.</strong> El ahorro se aplica automáticamente al pedido.';
        pack.querySelector('.w-pack-promise').innerHTML='Un diseño que os une.<br>Una pieza para cada una.';
        pack.querySelector('.w-pack-heading strong').textContent='Prepara vuestro dúo de edición';
      }
    }
    format(cents) { return this.money.format(Number(cents) / 100); }
    selectVariant(id, updateURL) {
      if (this._busy || this._uncertain) return;
      const variant = this.variants.get(String(id));
      if (!variant) return;
      this.current = variant; this.select.value = variant.id;
      if (!this._packEdited && this.packSelects[0]) this.packSelects[0].value = variant.id;
      const label = this.querySelector('[data-selected-name]'); if (label) label.textContent = variant.title;
      this.filterGallery(variant);
      this.syncVariantVisual(variant);
      this.updateDetailPhoto(variant);
      this.updateDelivery();
      this.updateEditionMessage(variant);
      const stickyCompare=this.querySelector('[data-sticky-compare]');
      stickyCompare.hidden=!(variant.compare>variant.price);stickyCompare.textContent=this.format(variant.compare);
      this.querySelector('[data-price]').textContent = this.format(variant.price);
      this.querySelector('[data-sticky-price]').textContent = this.format(variant.price);
      this.querySelector('[data-sticky-variant]').textContent = variant.title === 'Default Title' ? this.config.title : variant.title;
      const compare = this.querySelector('[data-compare]'), saving = this.querySelector('[data-saving]');
      compare.hidden = saving.hidden = !(variant.compare > variant.price);
      compare.textContent = this.format(variant.compare);
      saving.textContent = 'Ahorras ' + this.format(variant.compare - variant.price);
      const availability = this.querySelector('[data-availability]');
      const lowStock = variant.available && variant.inventoryTracked && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 5;
      availability.dataset.lowStock = String(lowStock);
      availability.textContent=this.stockMessage(variant);
      this.querySelectorAll('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === variant.id)));
      this.updateSwatches();
      this.refreshButtons();

      this.dispatchEvent(new CustomEvent('wrapjkt:variant-change', {detail: {id: variant.id}, bubbles: true}));
      // Gallery browsing never changes the purchased variant; selection is explicit.
      if (updateURL && window.URL) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        try { window.history.replaceState(window.history.state, '', url.toString()); } catch (_) {}
      }
    }
    refreshButtons() {
      const available = this.current && this.current.available;
      const locked = this._busy || this._uncertain;
      const outfit = this.querySelector('wj-outfit');
      const blocked = locked || outfit?.busy || outfit?.uncertain;
      const words = this.config.words;
      const label = (this._busy || outfit?.busy) ? words.busy : (this._uncertain || outfit?.uncertain) ? words.review : available ? words.add : words.soldOut;
      this.mainButton.disabled = this.stickyButton.disabled = blocked || !available;
      const mainLabel = this.mainButton.querySelector('[data-buy-label]');
      if (mainLabel) mainLabel.textContent = label;
      else this.mainButton.textContent = label;
      this.stickyButton.textContent = label;
      this.querySelectorAll('[data-buy-price],[data-repeat-price]').forEach(node => { node.textContent = this.current ? this.format(this.current.price) : ''; });
      this.querySelectorAll('[data-repeat-variant]').forEach(node => { node.textContent = this.current?.title || ''; });
      this.querySelectorAll('[data-repeat-submit]').forEach(button => { button.disabled = blocked || !available; button.textContent = label; });
      this.select.disabled = locked;
      this.querySelectorAll('[data-variant]').forEach(button => { button.disabled = locked; });
      this.packSelects.forEach(select => { select.disabled = locked; });
      this.querySelectorAll('[data-pack-toggle]').forEach(button => { button.disabled = locked; });
      this.querySelectorAll('[data-pack-choice]').forEach(button => { const v=this.variants.get(button.dataset.packChoice); button.disabled = locked || !v || !v.available; });
      this.updatePack();
    }
    updateSwatches() {
      const toggle = this.querySelector('[data-swatch-toggle]');
      if (!toggle) return;
      const buttons = [...this.querySelectorAll('[data-variant]')];
      const rowSize = Math.max(3, Math.min(8, Math.floor(((this.form?.clientWidth || 320) + 9) / 57)));
      const selected = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
      const visible = new Set([selected, ...buttons.filter(button => button !== selected).slice(0, rowSize - 1)]);
      buttons.forEach(button => { button.hidden = !this._colorsExpanded && !visible.has(button); });
      toggle.setAttribute('aria-expanded', String(!!this._colorsExpanded));
      toggle.textContent = this._colorsExpanded ? 'Recoger colores' : 'Ver todos los ' + this.config.variants.length + ' colores';
    }
    updatePack() {
      const variants = this.packSelects.map(s => this.variants.get(s.value));
      const valid = variants.length === 2 && variants.every(v => v && v.available);
      const tooFew = valid && variants[0].id === variants[1].id && variants[0].inventoryTracked && variants[0].inventoryQuantity < 2;
      variants.forEach((v,i) => {
        if (!v) return;
        const image=this.querySelector('[data-pack-image="'+i+'"]'), name=this.querySelector('[data-pack-name="'+i+'"]');
        name.textContent = v.title === 'Default Title' ? this.config.title : v.title;
        if (v.image) { const packSource=v.card||v.image; if (image.getAttribute('src') !== packSource) image.src = packSource; image.alt = name.textContent; image.hidden = false; } else { image.hidden = true; image.removeAttribute('src'); }
      });
      const subtotal = valid ? variants.reduce((sum,v) => sum + v.price, 0) : 0;
      this.querySelector('[data-pack-subtotal]').textContent = valid ? this.format(subtotal) : '—';
      this.querySelector('[data-pack-saving]').textContent = valid ? '−' + this.format(subtotal - Math.round(subtotal * .9)) : '—';
      this.querySelector('[data-pack-notice]').textContent = tooFew ? (this.dataset.kind==='estampada' ? 'Solo queda una unidad de este estampado. Puedes comprarla individualmente; el pack necesita dos.' : 'Solo queda una unidad de ese color. Elige otro para la segunda chaqueta.') : (this.dataset.kind==='estampada' ? 'Dos unidades de ' + this.config.title + ', con el mismo estampado.' : 'Comprueba las dos fotos y los nombres de color antes de añadir.');
      const total = valid ? Math.round(variants.reduce((sum,v) => sum + v.price, 0) * .9) : 0;
      this.querySelector('[data-pack-total]').textContent = valid ? this.format(total) : 'No disponible';
      this.querySelector('[data-pack-shipping]').textContent = valid && this.config.shippingPairEnabled ? this.config.shippingPairText : '';
      this.packButton.disabled = this._busy || this._uncertain || !valid || tooFew;
      this.packButton.textContent = this._busy ? 'Añadiendo…' : this._uncertain ? 'Revisa el carrito' : tooFew ? (this.dataset.kind==='estampada' ? 'No hay dos unidades disponibles' : 'Elige otro color para completar el pack') : valid ? 'Añadir mi pack · −10%' : 'Selecciona dos opciones disponibles';
    }
    markSlide(index) {
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      if (this._markedIndex === this.index) return;
      this._markedIndex = this.index;
      const zoomButton=this.querySelector('[data-zoom-current]');
      if(zoomButton) zoomButton.hidden=!this.slides[this.index].querySelector('[data-zoom-link]');
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
      const progress = this.querySelector('[data-gallery-progress]'); if (progress) progress.style.setProperty('--gallery-progress', ((this.index + 1) / this.slides.length * 100) + '%');
      this.thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current', String(i === this.index)));
      this.slides.forEach((slide,i) => {
        if (Math.abs(i - this.index) <= 1) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        if (i !== this.index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.disabled = this.index === 0;
      if (next) next.disabled = this.index === this.slides.length - 1;
    }
    closestSlide() {
      if (!this.track || !this.slides.length) return 0;
      if (this._slideOffsets && this._slideOffsets.length === this.slides.length) {
        const position = this.track.scrollLeft;
        let best = 0;
        for (let i = 1; i < this._slideOffsets.length; i++) {
          if (Math.abs(this._slideOffsets[i] - position) < Math.abs(this._slideOffsets[best] - position)) best = i;
        }
        return best;
      }
      const left = this.track.getBoundingClientRect().left;
      let closest = 0, distance = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.getBoundingClientRect().left - left);
        if (d < distance) { closest = i; distance = d; }
      });
      return closest;
    }
    finishGallery() {
      clearTimeout(this._scrollEndTimer);
      if (!this.isConnected) return;
      this._targetIndex = null;
      this.markSlide(this.closestSlide());
    }
    measureGallery() {
      if (!this.track || !this.track.clientWidth) { this._slideOffsets = null; return; }
      const left = this.track.getBoundingClientRect().left, scroll = this.track.scrollLeft;
      this._slideOffsets = this.slides.map(slide => scroll + slide.getBoundingClientRect().left - left);
    }
    alignGalleryWidth() {
      if (!this.track) return;
      const width = this.track.getBoundingClientRect().width;
      // iOS changes viewport height as its toolbar moves. That must not restart a slide.
      if (!width || Math.abs(width - this._galleryWidth) < 1) return;
      this._galleryWidth = width;
      this.measureGallery();
      this.go(this._targetIndex === null ? this.index : this._targetIndex, false);
    }
    go(index, smooth = true) {
      if (!this.track || !this.slides.length) return;
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      if (smooth && this._targetIndex === index) return;
      const left = this._slideOffsets ? this._slideOffsets[index] : this.track.scrollLeft + this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      const animate = smooth && !this._reduced && Math.abs(left - this.track.scrollLeft) > 1;
      clearTimeout(this._scrollEndTimer);
      this._targetIndex = animate ? index : null;
      this.markSlide(index);
      if (typeof this.track.scrollTo === 'function') this.track.scrollTo({left, behavior:animate ? 'smooth' : 'auto'});
      else this.track.scrollLeft = left;
      // Fallback for older Safari and scrolls that finish without a scrollend event.
      if (animate) this._scrollEndTimer = setTimeout(() => this.finishGallery(), 1200);
      const thumb = this.thumbs[index];
      if (thumb && thumb.parentElement) {
        const parent = thumb.parentElement, tr = thumb.getBoundingClientRect(), pr = parent.getBoundingClientRect();
        if (tr.left < pr.left || tr.right > pr.right) parent.scrollLeft += tr.left - pr.left - parent.clientWidth / 2 + thumb.clientWidth / 2;
      }
    }
    click(event) {
      const button = event.target.closest('button,a');
      if (!button || !this.contains(button)) return;
      if (button.dataset.appAction) this.dispatchEvent(new CustomEvent('wrapjkt:pdp-action', {bubbles:true,detail:{action:button.dataset.appAction,kind:this.dataset.kind,variantId:this.current?.id}}));
      if (this.presentationClick(event, button)) return;
      if (button.hasAttribute('data-pack-toggle')) { this.openPack(Number(button.dataset.packToggle)); }
      if (button.hasAttribute('data-close-pack')) this.closePack(true);
      if (button.hasAttribute('data-pack-choice')) {
        this._packEdited = true;
        const variant=this.variants.get(button.dataset.packChoice);
        if (!this._busy && !this._uncertain && variant && variant.available && this._packSlot != null) {
          this.packSelects[this._packSlot].value = variant.id; this.updatePack(); this.closePack(true);
        }
      }
      if (button.hasAttribute('data-variant')) { event.preventDefault(); this.selectVariant(button.dataset.variant, true); }
      if (button.hasAttribute('data-swatch-toggle')) { this._colorsExpanded = !this._colorsExpanded; this.updateSwatches(); }
      if (button.hasAttribute('data-thumb')) { event.preventDefault(); this.go(Number(button.dataset.thumb)); }
      if (button.hasAttribute('data-prev')) this.go(this.index - 1);
      if (button.hasAttribute('data-next')) this.go(this.index + 1);
      if (button.hasAttribute('data-zoom-link')) {
        event.preventDefault();
        // Touching a mobile gallery photograph never opens the overlay accidentally.
        // Keyboard activation remains available; the measurements diagram still opens.
        if(window.innerWidth>=1024 || !button.closest('.wj87__track') || event.detail===0) this.openZoom(button);
      }
      if(button.hasAttribute('data-zoom-current')) {
        const slide=this.slides[this.index], link=slide&&slide.querySelector('[data-zoom-link]');
        if(link){this.openZoom(link);this._zoomReturn=button;}
      }
      if (button.hasAttribute('data-close-zoom')) this.closeZoom();
      if (button.hasAttribute('data-sticky-submit')) {
        if (this.mainButton.disabled) return;
        if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.mainButton); else this.mainButton.click();
      }
      if (button.hasAttribute('data-open-details') || button.hasAttribute('data-scroll') || button.hasAttribute('data-back-to-buy')) {
        const id = button.getAttribute('href').slice(1);
        const target = button.hasAttribute('data-back-to-buy') ? this.form : document.getElementById(id);
        if (target && this.contains(target)) {
          event.preventDefault(); if (target.tagName === 'DETAILS') this.setAccordion(target, true, false);
          target.scrollIntoView({behavior:this._reduced ? 'auto' : 'smooth', block:'start'});
          if (target.tagName === 'DETAILS') target.querySelector('summary').focus({preventScroll:true});
        }
      }
    }
    updateSticky() {
      if (!this.sticky || !this.mainButton) return;
      if (this.querySelector("dialog[open]")) { this.sticky.hidden=true; this.classList.remove("has-sticky-buy"); return; }
      const rect = this.mainButton.getBoundingClientRect(), root = this.getBoundingClientRect();
      const viewport=window.innerHeight;
      const mainVisible=rect.bottom>0 && rect.top<viewport;
      const hasScrolled=rect.bottom<=80;
      this.sticky.hidden = !hasScrolled || mainVisible || root.top>=viewport || root.bottom<100 || this._zoomOpen;
      const picker = this.querySelector('[data-pack-picker]');
      const competing = [...this.querySelectorAll('[data-pack-submit],[data-outfit-submit],[data-repeat-submit]')].some(button => {
        if (!button || !button.getClientRects().length) return false;
        const box = button.getBoundingClientRect(); return box.bottom > 0 && box.top < viewport;
      });
      const outfit = this.querySelector('wj-outfit')?.getBoundingClientRect();
      if (competing || (picker && !picker.hidden) || (outfit && outfit.top < viewport && outfit.bottom > 0)) this.sticky.hidden = true;
      this.classList.toggle('has-sticky-buy',!this.sticky.hidden);
    }
    openZoom(link) {
      const modal = this.querySelector('[data-zoom]'), img = link.querySelector('img');
      this._zoomReturn = link; this._zoomOpen = true;
      this.querySelector('[data-zoom-img]').src = link.href;
      this.querySelector('[data-zoom-img]').alt = img ? img.alt : this.config.title;
      this.querySelector('[data-zoom-original]').href = link.href;
      modal.hidden = false;
      this._bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      modal.querySelector('button').focus(); this.updateSticky();
    }
    closeZoom() {
      this.querySelector('[data-zoom]').hidden = true; this._zoomOpen = false;
      document.body.style.overflow = this._bodyOverflow || '';
      if (this._zoomReturn && this._zoomReturn.isConnected) this._zoomReturn.focus({preventScroll:true});
      this.updateSticky();
    }
    zoomKeys(event) {
      if (!this._zoomOpen) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeZoom(); }
      if (event.key === 'Tab') {
        const modal = this.querySelector('[data-zoom]'), first = modal.querySelector('button'), last = modal.querySelector('a');
        if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    }
    feedback(message, isPack, error, focus = true) {
      const box = this.querySelector(isPack ? '[data-pack-feedback]' : '[data-feedback]');
      box.hidden = false; box.classList.toggle('is-error', !!error);
      box.querySelector('[data-feedback-text]').textContent = message;
      if (!focus) return;
      box.focus({preventScroll:true});
      const r = box.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 85 || r.top < 0) box.scrollIntoView({behavior:this._reduced ? 'auto' : 'smooth',block:'center'});
    }
    async add(ids, isPack) {
      if (this._busy || this._uncertain || this.querySelector('wj-outfit')?.busy || this.querySelector('wj-outfit')?.uncertain) return;
      this._busy = true; this.refreshButtons();
      this.querySelector('wj-outfit')?.update();
      const quantities = new Map(); ids.forEach(id => quantities.set(id,(quantities.get(id) || 0) + 1));
      const payload = {items:Array.from(quantities, ([id,quantity]) => ({id:id,quantity:quantity}))};
      let response, data, completed = false;
      const controller = window.AbortController ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(),25000) : null;
      try {
        const root = this.config.root.endsWith('/') ? this.config.root : this.config.root + '/';
        response = await fetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload),...(controller ? {signal:controller.signal} : {})});
        try { data = await response.json(); } catch (_) { throw new Error('No pudimos confirmar la respuesta.'); }
        if (timeout) clearTimeout(timeout);
        if (!response.ok) {
          this._uncertain = true;
          // A cart can have changed even if stock rejects part of the requested quantity.
          const reason = typeof data.description === 'string' ? data.description : 'No se ha podido completar la solicitud.';
          this.feedback(reason + ' Revisa el carrito antes de repetir el pedido.',isPack,true);
        } else {
          completed = true;
          // Preserve the installed app. Never open the theme's second drawer.
          // UI failure must not trigger another cart/add.js request.
          let appOpened = false;
          try {
            if (window.essentialCartApi && typeof window.essentialCartApi.openCart === 'function') {
              appOpened = await Promise.race([
                Promise.resolve(window.essentialCartApi.openCart()).then(() => true),
                new Promise(resolve => setTimeout(() => resolve(false), 1800))
              ]);
            }
          } catch (_) { /* Visible confirmation + cart link remain usable. */ }
          this.feedback(isPack ? 'Las dos chaquetas están en tu carrito. Allí puedes revisar el descuento aplicado y continuar con tu pedido.' : 'Tu WRAPJKT está en el carrito. Puedes seguir mirando o continuar con tu pedido.',isPack,false,!appOpened);
          this.dispatchEvent(new CustomEvent('wrapjkt:cart-added',{bubbles:true,detail:{items:data.items || [],quantity:ids.length}}));
        }
      } catch (_) {
        if (!completed) {
          this._uncertain = true;
          this.feedback('La conexión no ha permitido confirmar el resultado. Para evitar duplicados, revisa el carrito antes de volver a añadir. No hemos repetido la petición.',isPack,true);
        }
      } finally {
        if (timeout) clearTimeout(timeout);
        this._busy = false; this.refreshButtons();
        this.querySelector('wj-outfit')?.update();
      }
    }
  }
  window.customElements.define('wj-pdp-v98', WrapJktPDP98);
})();
